import { ImagesSubComponent } from '../images.sub.component';
import { isMobile } from '../../../_common/client/breakpoint';
import { openViewInMyRoomSheet } from './view-in-my-room-sheet';

export class ViewInMyRoomButtonSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_view-in-my-room-button';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        if (!isMobile()) {
            return;
        }

        this.createAndAppendButton();
        this.performViewTracking();
    }

    private createAndAppendButton() {
        if (this.getRootElement().dataset.showButton !== 'true') {
            return;
        }
        const buttonElement = document.createElement('oc-button-v1');
        buttonElement.classList.add('pdp_view-in-my-room-button__button');
        buttonElement.setAttribute('icon-type-left', 'sparkles');
        buttonElement.setAttribute('size', '50');
        buttonElement.setAttribute('variant', 'secondary');
        buttonElement.innerHTML = '<b>In meinem Raum ansehen</b>';
        buttonElement.addEventListener('click', () => openViewInMyRoomSheet());
        this.getRootElement().appendChild(buttonElement);
        this.getRootElement().classList.add('pdp_view-in-my-room-button');
    }

    private performViewTracking() {
        this.trackView({
            product_InteriorDesignConsultant: 'True',
        });
    }

    protected onItemChanged() {}
}
